import { ApplicationRef, Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { SwUpdate, VersionReadyEvent } from '@angular/service-worker';
import { UpdateDialogComponent } from '@shared/components/update-dialog/update-dialog.component';
import { filter, concat, first, interval } from 'rxjs';
import { AlertService } from './alert/alert.service';

@Injectable({
  providedIn: 'root',
})
export class UpdateService {
  constructor(
    private appRef: ApplicationRef,
    private updates: SwUpdate,
    private alertService: AlertService,
    private dialog: MatDialog
  ) {
    console.log(`Service workers enabled: ${this.updates.isEnabled}`);

    // Allow the app to stabilize first, before starting
    // polling for updates with `interval()`.
    const appIsStable$ = this.appRef.isStable.pipe(
      first((isStable) => isStable === true)
    );
    const everyTenMinutes$ = interval(10 * 60 * 1000);
    const intervalOnceAppIsStable$ = concat(appIsStable$, everyTenMinutes$);

    intervalOnceAppIsStable$.subscribe(async () => {
      console.log('Checking for update...');

      try {
        const updateFound = await this.updates.checkForUpdate();
        console.log(
          updateFound
            ? 'A new version is available.'
            : 'Already on the latest version.'
        );
      } catch (err) {
        console.error('Failed to check for updates:', err);
      }
    });
  }

  init(): void {
    this.promptIfUpdate();
    this.checkForUnrecoverableState();
  }

  private promptIfUpdate(): void {
    this.updates.versionUpdates
      .pipe(
        filter((evt): evt is VersionReadyEvent => evt.type === 'VERSION_READY')
      )
      .subscribe(() => {
        this.dialog.open(UpdateDialogComponent, {
          disableClose: true,
        });
      });
  }

  private checkForUnrecoverableState(): void {
    this.updates.unrecoverable.subscribe((event) => {
      console.log(event.reason);

      this.alertService.setAlert({
        type: 'error',
        message:
          'An error occurred, the page will now reload.\n' + event.reason,
      });

      window.location.reload();
    });
  }
}
